// Pure reporting-period helpers (isQuarterEndReportingPeriod, toOrchestratorPeriod) now live in the
// models layer at src/models/reports/ReportPeriod.ts so the service layer does not depend on a
// component-level module. Import them from there.

// ---- UI copy (from the Product mockup New_mockup_reporting.html) --------------------------------

export const GENERATE_BUTTON_LABELS = {
    FULL_REFRESH: 'Full Refresh',
};

export const GENERATE_BUTTON_TOOLTIPS = {
    FULL_REFRESH:
        'Generates the complete TP Tax report package for all active CLIs. Admin only.',
};

export const BANNER_MESSAGES = {
    NO_REPORTS:
        'No reports have been generated for this period. Use "Full Refresh" to create a report package, '
        + 'or wait for the scheduled Day 7 refresh.',
    VAR_PLI_ONLY:
        'This is a quick VAR + PLI refresh. MAR (PnL), CWB, and LEF were not updated. '
        + 'To refresh those reports, generate a Full Refresh.',
    QUARTER_END:
        'This is a quarter-end close period. Both Day 7 and Day 11 scheduled reports are available.',
};

export const FILTER_LABELS = {
    ACCOUNTING_PERIOD: 'Accounting Period',
    REPORT_VERSION: 'Report Version',
};

// After a Full Refresh is accepted, the new run is created asynchronously (trigger → SQS → coordinator
// → the lambda that writes the PENDING_FDV / PHASE1_RUNNING JobRegistry row). Wait before re-fetching
// the version list so the newly-running run has time to appear; refetching too early races that
// pipeline and returns the stale list with no in-progress run — which lets the Full Refresh button
// re-enable in the gap. The button + a loader stay disabled for this whole window, so it is sized to
// comfortably clear the async write rather than the bare minimum.
export const POST_TRIGGER_VERSIONS_REFRESH_DELAY_MS = 10000;

export const FULL_REFRESH_MESSAGES = {
    CONFIRM_TITLE: 'Generate Full Refresh',
    confirmBody: (period: string): string =>
        `This will generate a complete TP Tax report package for all active CLIs `
        + `for ${period}. Generation runs in the background and may take a while. Continue?`,
    SUCCESS: 'Full Refresh started. Generation runs in the background and may take a while; the new run '
        + 'appears as "in progress" in the Report Version list and in History.',
    REFRESHING: 'Updating report versions…',
};
